<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component'; 
    import { SavingState } from '@common/Common';

    @Component({
        props: {
            savingState: {
                type: String, 
                required: true,
                validator: (value: string) =>
                {
                    // Optional: validate that the value is one of the enum values
                    return Object.values(SavingState).includes(value);
                }
            },
            isFormSubmit: {
                type: Boolean,
                default: false
            }
        }
    })
    export default class SaveButton extends Vue
    {
        get buttonText() {
            switch (this.savingState) {
                case SavingState.InProgress:
                    return 'Saving...';
                case SavingState.Pending:
                    return 'Save changes';
                case SavingState.Saved:
                    return 'Saved';
                default:
                    return 'Save';
            }
        }

        get buttonClass() 
        {
            switch (this.savingState)
            {
                case SavingState.InProgress:
                    return 'btn-warning';
                case SavingState.Pending:
                    return 'btn-warning';
                case SavingState.Saved:
                    return 'btn-success';
                default:
                    return 'btn-success';
            }
        }

        get isButtonDisabled() {
            return this.savingState === SavingState.InProgress || this.savingState === SavingState.Saved;
        }

        saveChanges()
        {
            if (this.isFormSubmit)
            {
                return;
            }

            this.$emit('saveChanges');
        }
    }
</script>

<template>
    <button :type="isFormSubmit ? 'submit' : 'button'" :class="['btn', buttonClass]" :disabled="isButtonDisabled" @click="saveChanges" style="padding: 0.7em 2em;">
        {{ buttonText }}
    </button>
</template>